import { FilingStatus } from './types';

// Note: These are projected standard deduction amounts for tax year 2026.
export const STANDARD_DEDUCTIONS: Record<FilingStatus, number> = {
  [FilingStatus.SINGLE]: 15700,
  [FilingStatus.MARRIED_FILING_JOINTLY]: 31400,
  [FilingStatus.MARRIED_FILING_SEPARATELY]: 15700,
  [FilingStatus.HEAD_OF_HOUSEHOLD]: 23550,
};

// Per user request.
export const SALT_CAPS: Record<FilingStatus, number> = {
  [FilingStatus.SINGLE]: 40000,
  [FilingStatus.MARRIED_FILING_JOINTLY]: 40000,
  [FilingStatus.MARRIED_FILING_SEPARATELY]: 20000,
  [FilingStatus.HEAD_OF_HOUSEHOLD]: 40000,
};